export default function ContactInfoNotice() {
  return (
    <p className="typography-product-caption mt-ds-xl text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
      We may share your contact information with the organizer so they can get in touch.
    </p>
  );
}
